import React, { Component } from 'react';
import { Container } from 'reactstrap';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {BasicAnimation} from "../animations/BasicAnimation";


export class Hero extends Component {


  constructor(props) {
    super(props);

    let align;

    switch(this.props.align){
      case "right":
      case "flex-end":
        align = "flex-end";
        this.alignContainer = "align-items-end";
        break;
      case "left":
      case "flex-start":
        align = "flex-start";
        this.alignContainer = "align-items-start";
        break;
      case "center":
        align = this.props.align;
        this.alignContainer = "align-items-center";
        break;
      default:
        align = "center";
    }

    this.alignment = {
      "alignItems": align
    };

    this.textAlign = {
      textAlign: align
    };
  }

  render() {
    return (
      <div className={"hero d-flex " + this.props.className + " " + (this.props.image ? " "  : "background-gradient")}>
          <Container className={"hero-content"} style={{ ...this.alignment }}>
            <BasicAnimation duration={800} delay={0}>
              <SmallUnderline align={ this.props.align || "left" }>
                <h1 className={"text-center"}>{ this.props.title }</h1>
              </SmallUnderline>
            </BasicAnimation>
            <BasicAnimation duration={800} delay={300}>
              <div align={ this.props.align || "left" }>
                <div className={"hero-body"} style={{ ...this.textAlign }}
                     dangerouslySetInnerHTML={{
                       __html:  typeof this.props.subtitle === 'string' ? this.props.subtitle : ""
                     }}/>
              </div>
            </BasicAnimation>
          </Container>
        <BasicAnimation duration={500}>
          {
            this.props.blend &&
            <div className={ "blend-blue-gradient"}/>
          }
          <div className="background-image" style={{ backgroundImage: `url(${this.props.image || require('../../assets/images/empty.png')})`}}/>
        </BasicAnimation>
        <div className={"backgroound-color-container background-gradient"}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hero/Hero.js